exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".checkout--21wY1{padding:14px;margin-bottom:0px}\n", "", {"version":3,"sources":["/workspace/src/widget/event_components/Checkout/views/checkout.scss"],"names":[],"mappings":"AAAA,iBACE,aACA,iBAAkB,CAAA","file":"checkout.scss","sourcesContent":[".checkout {\n  padding: 14px;\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"checkout": "checkout--21wY1"
};